// tutorial
// https://medium.com/%E6%BC%AB%E7%AF%89%E8%98%AD%E6%A0%BC/%E5%A6%82%E4%BD%95%E5%9C%A8-vue-%E8%A3%A1%E9%9D%A2%E4%BD%BF%E7%94%A8-font-awesome-c0d8f66c1e3b

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
	faBars,
	faTimes,
	faPlayCircle,
} from '@fortawesome/free-solid-svg-icons';
import {
	faFacebook,
	faInstagram,
	faYoutube,
} from '@fortawesome/free-brands-svg-icons';

library.add(faBars, faTimes, faPlayCircle, faFacebook, faInstagram, faYoutube);
export default FontAwesomeIcon;
